import React, { useEffect, useRef, useState } from 'react'
import Slider from 'react-slick';
import technology_img from "../../assets/images/contents/technology-slider.png"
import { useMediaQuery } from '@mui/material';
import theme from '../../assets/themes/theme';
import { useTranslation } from 'react-i18next';

const TechnologyPaginationSlick = () => {
  const {t} = useTranslation()

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (current) => setActiveDot(current),
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: "linear"
  };

  const [activeDot, setActiveDot] = useState(0);

  const sliderRef = useRef(null);

  const handleDotClick = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
      setActiveDot(index);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (sliderRef.current) {
        setActiveDot(sliderRef.current.innerSlider.state.currentSlide);
      }
    }, settings.autoplaySpeed);

    return () => clearInterval(interval);
  }, [settings.autoplaySpeed]);




  const contentArray = [
    {
      id: 1,
      title: t('technology.pagination-title-1'),
      content: t('technology.pagination-content-1')
    },
    {
      id: 2,
      title: t('technology.pagination-title-2'),
      content: t('technology.pagination-content-2')
    },
    {
      id: 3,
      title: t('technology.pagination-title-3'),
      content: t('technology.pagination-content-3')
    },
    {
      id: 4,
      title: t('technology.pagination-title-4'),
      content: t('technology.pagination-content-4')
    },
    {
      id: 5,
      title: t('technology.pagination-title-5'),
      content: t('technology.pagination-content-5')
    },

  ];

  const isMatch = useMediaQuery(theme.breakpoints.down("navbar"));

  return (
    <div className='col-sm-12 pt-50'>
      {!isMatch ? <div className='row'>
        <div className='col-lg-6'>
          <ul className='list-unstyled'>
            {contentArray.map((item, index) => (
              <li
                key={item.id}
                className={`checked-line technology-slider-content ${activeDot === index ? "active" : ''}`}
                onClick={() => handleDotClick(index)}
              >
                <span className='font-weight-semi-bold'>{item.title}</span>&nbsp;{item.content}
              </li>
            ))}
          </ul>
        </div>
        <div className='col-lg-6'>
          <div className='technology-bg-slider'>
            <Slider ref={sliderRef} {...settings}>
              <div>
                <div className='technology-slider-img'>
                  <img src={technology_img} alt="" />
                </div>
              </div>
              <div>
                <div className='technology-slider-img'>
                  <img src={technology_img} alt="" />
                </div>
              </div><div>
                <div className='technology-slider-img'>
                  <img src={technology_img} alt="" />
                </div>
              </div><div>
                <div className='technology-slider-img'>
                  <img src={technology_img} alt="" />
                </div>
              </div><div>
                <div className='technology-slider-img'>
                  <img src={technology_img} alt="" />
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
        :
        <div className='row'>
          <div className="col-sm-12">
            <div className='technology-bg-slider'>
              <Slider ref={sliderRef} {...settings}>
                {contentArray.map((item, index) => (
                  <div>
                    <div className='technology-slider-img-center'>
                      <img src={technology_img} alt="" className='img-slider-w600-responsive'/>
                      <p className='font-weight-semi-bold font-20 pt-20'>{item.title}</p>
                      <p className='pt-20'>{item.content}</p>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      }



    </div>

  )
}

export default TechnologyPaginationSlick